import type { RoomListCapabilityProps } from '../components/RoomFilter/CapabilityFilterType';
import { FeatureFilterItemType } from '../components/RoomFilter/FeatureFilterItemType';
import getStore from '../store/store';
import { isNullOrWhiteSpace } from 'owa-string-utils';

export default function getRoomlistCapabilities() {
    let roomListCapabilities: RoomListCapabilityProps = {
        maxCapacity: 0,
        minFloor: Infinity,
        maxFloor: -Infinity,
        hasFeatures: [],
        hasTags: false,
    };

    if (getStore().roomListViewState.isSearchingForRooms) {
        return roomListCapabilities;
    }

    getStore()?.roomListViewState?.rooms?.forEach(room => {
        roomListCapabilities.maxCapacity = room.capacity
            ? Math.max(room.capacity, roomListCapabilities.maxCapacity)
            : roomListCapabilities.maxCapacity;
        roomListCapabilities.maxFloor = room.floor
            ? Math.max(room.floor, roomListCapabilities.maxFloor)
            : roomListCapabilities.maxFloor;
        roomListCapabilities.minFloor = room.floor
            ? Math.min(room.floor, roomListCapabilities.minFloor)
            : roomListCapabilities.minFloor;
        roomListCapabilities.hasFeatures[FeatureFilterItemType.Audio] =
            roomListCapabilities.hasFeatures[FeatureFilterItemType.Audio] ||
            !isNullOrWhiteSpace(room.audioDeviceName);
        roomListCapabilities.hasFeatures[FeatureFilterItemType.Display] =
            roomListCapabilities.hasFeatures[FeatureFilterItemType.Display] ||
            !isNullOrWhiteSpace(room.displayDeviceName);
        roomListCapabilities.hasFeatures[FeatureFilterItemType.Video] =
            roomListCapabilities.hasFeatures[FeatureFilterItemType.Video] ||
            !isNullOrWhiteSpace(room.videoDeviceName);
        roomListCapabilities.hasFeatures[FeatureFilterItemType.Accessible] =
            roomListCapabilities.hasFeatures[FeatureFilterItemType.Accessible] ||
            room.isWheelChairAccessible;
        roomListCapabilities.hasTags = roomListCapabilities.hasTags || room.tags?.length > 0;
    });

    return roomListCapabilities;
}
